export default "__VITE_ASSET__e0e3a83c__"